'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHistory = function MdHistory(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 13.4h2.5v7l5.9 3.5-1.3 2-7.1-4.3v-8.2z m1.6-8.4q6.2 0 10.6 4.4t4.4 10.6-4.4 10.6-10.6 4.4-10.5-4.4l2.3-2.4q3.5 3.4 8.2 3.4 4.9 0 8.3-3.4t3.5-8.2-3.5-8.2-8.3-3.4-8.2 3.4-3.4 8.2h5l-6.7 6.7-0.2-0.2-6.5-6.5h5q0-6.2 4.5-10.6t10.5-4.4z' })
        )
    );
};

exports.default = MdHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/history.js
// module id = 1099
// module chunks = 36573943044255 79611799117203 213534597649335